export const AgeDateDisplayEnum = Object.freeze({
	AGE_ONLY: "age",
	DATE_ONLY: "date",
	FULL: "full",

})
